import { api } from './client';

export interface SisAgingRow {
  partyId: number;
  itemId: number;
  storeName: string;
  group: string;
  itemCode: string;
  itemBarcode: string;
  itemName: string;
  imageUrl?: string | null;
  unit: string;
  received: number;
  sold: number;
  returned: number;
  netSold: number;
  onHand: number;
  sellThroughPct: number;
  oldestDays: number;
  d0_30: number;
  d31_60: number;
  d61_90: number;
  d90plus: number;
}

export interface SisAgingSummary {
  lines: number;
  onHand: number;
  received: number;
  netSold: number;
  sellThroughPct: number;
  d0_30: number;
  d31_60: number;
  d61_90: number;
  d90plus: number;
}

export interface SisAgingResponse {
  rows: SisAgingRow[];
  summary: SisAgingSummary;
}

export async function getSisAging(filter: { partyId?: number; group?: string } = {}): Promise<SisAgingResponse> {
  const r = await api.get<SisAgingResponse>('/sis-stock/aging', { params: filter });
  return r.data;
}
